import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const SearchInputWrapper = styled.div`
  margin: ${layout.measurements.spacing100};
  margin-bottom: ${layout.measurements.spacing050};

  ${media.mediumDown`
    margin: ${layout.measurements.spacing050};
  `}
`;
